export default class Entity {
  static make() {
    return {};
  }
}
